import { render, staticRenderFns } from "./AppNavigationContactsItem.vue?vue&type=template&id=5889d964&scoped=true"
import script from "./AppNavigationContactsItem.vue?vue&type=script&lang=js"
export * from "./AppNavigationContactsItem.vue?vue&type=script&lang=js"
import style0 from "./AppNavigationContactsItem.vue?vue&type=style&index=0&id=5889d964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5889d964",
  null
  
)

export default component.exports